import React from 'react';
import { GlobalState, UI } from '@leverege/ui-redux';
import { DeckGLLayer } from '@leverege/ui-google-maps-elements';
import { TileLayer } from '@deck.gl/geo-layers';
import { BitmapLayer } from '@deck.gl/layers';
import Model from "./ItemTileModel.js";
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY_ARRAY = Object.freeze([]);
export default function ItemTileRenderer(opts) {
  const {
    objRef,
    model
  } = opts;
  const obj = GlobalState.get()?.models?.lookup?.[objRef?.id];
  if (!obj || !Model.getVisible(model)) {
    return EMPTY_ARRAY;
  }
  const mapLayers = obj?.metadata?.mapLayers;
  if (!mapLayers) return EMPTY_ARRAY;
  const opacity = model ? Model.getOpacity(model) || 1 : 1;
  const sid = `${obj.id}-tile`;
  const rtn = [];
  mapLayers.forEach((layer, index) => {
    const lid = `${sid}-${index}`;
    const {
      source
    } = layer;
    const {
      minzoom: minZoom,
      maxzoom: maxZoom,
      tileSize,
      tiles,
      bounds
    } = source;
    const mapEditing = UI.get(GlobalState.get(), 'mapEditing');
    const op = mapEditing ? 0.1 : opacity;
    rtn.push(/*#__PURE__*/_jsx(DeckGLLayer, {
      id: lid,
      layer: new TileLayer({
        data: tiles,
        minZoom,
        maxZoom,
        tileSize,
        opacity: op,
        extent: bounds,
        renderSubLayers: props => {
          const {
            bbox: {
              west,
              south,
              east,
              north
            }
          } = props.tile;
          if (west == null || south == null || east == null || north == null) {
            return null;
          }
          return new BitmapLayer(props, {
            data: null,
            image: props.data,
            bounds: [west, south, east, north]
          });
        }
      })
    }, lid));
  });
  return rtn;
}